import axios from 'axios';
import {backendHost} from '../../config';

export const getWithdrawalsList = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/withdrawals`, {params});
};